import { Autocomplete, Box, Button,CircularProgress, Dialog, DialogContent, DialogTitle, FormControl, FormControlLabel, Grid, MenuItem, Radio, RadioGroup, Select, TextField, Typography} from '@mui/material';
import React, { useState, useEffect } from 'react';
import {control, Controller, set, useForm} from 'react-hook-form';
import { BannerServices } from '../../../Marketing/banners/BannerServices';
import { CrudServices } from '../../../MasterService/CrudServices';
// import { BannerServices } from './BannerServices';
// import { CrudServices } from '../../MasterService/CrudServices';

const GenerateAppUrl = ({onClose, onSelectUrl}) => {
    
    const {control, handleSubmit, reset, formState:{isDirty},watch,setValue} = useForm({
        mode: 'onSubmit',
        defaultValues: {
            navigate_to:'',
            serviceExpert:null,
            category:null,
            subCategory:null,
            masterService:null,
            childService:null,
            brand:null,
            appUrl:'',
        },
    });
    const [isSubmitting, setIsSubmitting] = useState(false);
    
    // const [expertList, setExpertList] = useState([]);
    // const [loadingServiceExpertList, setLoadingServiceExpertList] = useState(false);
    // const fetchServiceExpertList = async() => {
    //     // setLoadingServiceExpertList(true);
    // }
    // useEffect(() => {
    //     fetchServiceExpertList();
    // }, []);
    const navigateTo = watch('navigate_to');
    const [loadingCategoryList, setLoadingCategoryList] = useState(false);
    
    const [loadingSubCategoryList, setLoadingSubCategoryList] = useState(false);
    const [categoryList, setCategoryList] = useState([]);
    const [subCategoryList, setSubCategoryList] = useState([]);
    const [serviceList, setServiceList] = useState([]);
    const [childServiceList, setChildServiceList] = useState([]);
    const [brandList, setBrandList] = useState([]);

    const [loadingServiceExpertList, setLoadingServiceExpertList] = useState(false);
    const [expertList, setExpertList] = useState([]);

    useEffect(()=>{
        setValue('appUrl','');
        // setValue('navigate_to','');
        setValue('serviceExpert','');
        setValue('category','');
        setValue('subCategory','');
        setValue('masterService','');
        setValue('childService','');
        setValue('brand','');
        const fetchCategoryList= async()=>{
            try {
            const categoryListResponse = await CrudServices.categoryList();
            console.log("category list Response:",categoryListResponse);
            if(categoryListResponse.success===1){
                setCategoryList(categoryListResponse.data)
            }
            } catch (error) {
            
            }
        }
        const fetchExpertList= async()=>{
            // const response = await NotificationServices.fetchAllFilteredExperts({});
            const response = await BannerServices.allValidExperts();
            if (response.success == '1') {
                setExpertList(response.data.experts);
            }

        }
        if(navigateTo == 'category' || navigateTo == 'sub-category' || navigateTo == 'master-service' || navigateTo == 'child-service' || navigateTo == 'child-service-home' || navigateTo == 'serviceBrand'){
            fetchCategoryList();
        } else if(navigateTo == 'expert-profile'){
            fetchExpertList();
        }
    },[navigateTo]);

    const categoryId = watch('category')?.id;
    useEffect(()=>{
        const fetchSubCategoryList= async()=>{
            try {
            const subCategoryListResponse = await CrudServices.subCategoryList({categoryId});
            console.log("subCategory list Response:",subCategoryListResponse);
            if(subCategoryListResponse.success===1){
                setSubCategoryList(subCategoryListResponse.data)
            }
            } catch (error) {
            
            }
        }
        if(categoryId){ 
            setValue('subCategory',null);
            setValue('masterService',null);
            setValue('childService',null);
            setValue('brand',null);
            setServiceList([]);
            setChildServiceList([]);
            setBrandList([]);
            fetchSubCategoryList();
        }else{
            setSubCategoryList([]);
            //remove subcategory from filterOption
            setValue('subCategory',null);
        }
    },[categoryId]);

    const subCategoryId = watch('subCategory')?.id;
    useEffect(()=>{
        const fetchServiceList= async()=>{
            try {
            const serviceListResponse = await BannerServices.serviceList(subCategoryId);
            console.log("service list Response:",serviceListResponse);
            if(serviceListResponse.success===1){
                setServiceList(serviceListResponse.data)
            }
            } catch (error) {
            
            }
        }
        if(subCategoryId){
            setValue('masterService',null);
            setValue('childService',null);
            setValue('brand',null);
            setChildServiceList([]);
            setBrandList([]);
            fetchServiceList();
        }else{
            setServiceList([]);
            //remove service from filterOption
            setValue('masterService',null);
        }
    },[subCategoryId]);

    const masterServiceId = watch('masterService')?.masterServiceId;
    useEffect(()=>{
        if(masterServiceId){
            setValue('childService',null);
            setValue('brand',null);
            const childServices = serviceList.find(service => service.masterServiceId === masterServiceId)?.childServices || [];
            setChildServiceList(childServices);
            if(navigateTo == 'serviceBrand'){
                const brands = serviceList.find(service => service.masterServiceId === masterServiceId)?.brands || [];
                // const filteredBrands = brands.filter(brand => brand.brandId != '1');
                if (brands.length > 0){
                    setBrandList(brands);
                }else {
                    setBrandList([{
                        "brandId": 1,
                        "brandDetail": {
                            "title": "Generic",
                        }
                    }])
                }
            }else{
                setBrandList([]);
            }
        }
    },[masterServiceId]);

    const childServiceId = watch('childService')?.childServiceId;
    useEffect(()=>{
        if(childServiceId && masterServiceId && navigateTo == 'serviceBrand'){
            const brands = serviceList.find(service => service.masterServiceId === masterServiceId)?.brands || [];
            // const filteredBrands = brands.filter(brand => brand.brandId != '1');
            if (brands.length > 0){
                setBrandList(brands);
            }else {
                setBrandList([{
                    "brandId": 1,
                    "brandDetail": {
                        "title": "Generic",
                    }
                }])
            }
        }
    },[childServiceId]);
    useEffect(()=>{
        setBrandList([]);
    },[navigateTo, categoryId, subCategoryId, masterServiceId]);
    const [copiedAppUrl, setCopiedAppUrl] = useState('');
    const handleCopy = () => {
        const appUrl = watch('appUrl') || '';
        if (appUrl) {
          navigator.clipboard.writeText(appUrl)
            .then(() => {
                setCopiedAppUrl(appUrl);
            })
        }
    };
    const onSubmit = async(data) => {
        console.log(data);
        let appUrl = '';
        if(navigateTo == 'category'){
            appUrl = `/subCategoryScreen?subCategoryTitle=${encodeURIComponent(watch('category')?.title)}&categoryId=${watch('category')?.id}`;
        }
        else if(navigateTo == 'sub-category'){
            appUrl = `/subCategoryScreen?subCategoryTitle=${encodeURIComponent(watch('category')?.title)}&categoryId=${watch('category')?.id}&subCategoryId=${watch('subCategory')?.id}`;
        } 
        else if(navigateTo == 'master-service'){
            appUrl = `/childServiceScreen?masterServiceTitle=${encodeURIComponent(watch('masterService')?.title)}&masterServiceId=${watch('masterService')?.masterServiceId}`
        } else if(navigateTo == 'child-service'){
            appUrl =`/childServiceScreen?masterServiceTitle=${encodeURIComponent(watch('masterService')?.title)}&masterServiceId=${watch('masterService')?.masterServiceId}&childServiceId=${watch('childService')?.childServiceId}`;
        } else if(navigateTo == 'child-service-home'){
            appUrl =`/childServiceFromHomeScreenView?masterServiceTitle=${encodeURIComponent(watch('masterService')?.title)}&masterServiceId=${watch('masterService')?.masterServiceId}&childServiceId=${watch('childService')?.childServiceId}`;
        } else if(navigateTo == 'banner-page'){
            appUrl = `/bannerScreen`;
        } else if(navigateTo == 'expert-profile'){
            appUrl = `/expertDetailsScreen?providerId=${watch('serviceExpert')}`;
        } else if(navigateTo == 'serviceBrand'){
            appUrl =`/childServiceScreen?masterServiceTitle=${encodeURIComponent(watch('masterService')?.title)}&masterServiceId=${watch('masterService')?.masterServiceId}&childServiceId=${watch('childService')?.childServiceId}&brandId=${watch('brand')?.brandId}`;
        }
        // const subCategoryTitle = "Men's & kids' saloon";
        // const categoryId = 1;

        // const encodedUrl = `/subCategoryScreen?subCategoryTitle=${encodeURIComponent(subCategoryTitle)}&categoryId=${categoryId}`;

        // console.log(encodedUrl);
        setValue('appUrl',appUrl);
        if (appUrl && typeof onSelectUrl === 'function') {
            onSelectUrl(appUrl);
        }
    }
  return (
    <Box>
        <Box sx={{display:'flex',justifyContent:'space-between',alignItems:'center',p:'1%',borderBottom:'1px solid #ccc'}}>
            <Typography sx={{fontSize:'0.85rem',fontWeight:600}} > Generate Customer App Url </Typography>
            <Button disabled={isSubmitting} size='small' variant='outlined' color='error' onClick={onClose}>Close</Button>
        </Box>
        <Box component="form" onSubmit={handleSubmit(onSubmit)} sx={{p:'2%'}}>
            <Grid container spacing={2}>
                <Grid item xs={12} >
                    <Grid container spacing={1} alignItems="center">
                        <Grid item xs={12} sm={3}>
                            <Typography sx={{fontSize:'0.85rem',fontWeight:600}}>Navigate To <Box component={'span'} sx={{color:'#d32f2f'}}>*</Box></Typography>
                        </Grid>
                        <Grid item xs={12} sm={9}>
                            <Box sx={{display:'flex',flexDirection:'row',alignItems:'center',gap:2}}>
                                {/* <Typography sx={{fontSize:'0.85rem',fontWeight:600 }}>Navigate To  : </Typography> */}
                                <FormControl component="fieldset" >
                                    <Controller
                                        name="navigate_to"
                                        control={control}
                                        rules={{ 
                                            // required:'select isSlider',
                                        }}
                                        render={({ field }) => (
                                        <RadioGroup {...field} row >
                                            <FormControlLabel
                                                value={'expert-profile'} 
                                                control={<Radio sx={{ '& .MuiSvgIcon-root': { fontSize: '0.9rem' } }}/>} 
                                                label="Expert-Profile" 
                                                sx={{
                                                    '& .MuiFormControlLabel-label': {
                                                    fontSize: '0.75rem'
                                                    }
                                                }}
                                            />
                                            <FormControlLabel
                                                value={'category'}
                                                control={<Radio sx={{ '& .MuiSvgIcon-root': { fontSize: '0.9rem' } }}/>} 
                                                label="Category" 
                                                sx={{
                                                    '& .MuiFormControlLabel-label': {
                                                    fontSize: '0.75rem'
                                                    }
                                                }}
                                            />
                                            <FormControlLabel 
                                                value={'sub-category'} 
                                                control={<Radio sx={{ '& .MuiSvgIcon-root': { fontSize: '0.9rem' } }}/>} 
                                                label="Sub-Category" 
                                                sx={{
                                                    '& .MuiFormControlLabel-label': {
                                                    fontSize: '0.75rem'
                                                    }
                                                }}
                                            />
                                            <FormControlLabel 
                                                value={'master-service'} 
                                                control={<Radio sx={{ '& .MuiSvgIcon-root': { fontSize: '0.9rem' } }}/>} 
                                                label="Master Service" 
                                                sx={{
                                                    '& .MuiFormControlLabel-label': {
                                                    fontSize: '0.75rem'
                                                    }
                                                }}
                                            />
                                            <FormControlLabel 
                                                value={'child-service'} 
                                                control={<Radio sx={{ '& .MuiSvgIcon-root': { fontSize: '0.9rem' } }}/>} 
                                                label="Child-Service" 
                                                sx={{
                                                    '& .MuiFormControlLabel-label': {
                                                    fontSize: '0.75rem'
                                                    }
                                                }}
                                            />
                                            <FormControlLabel
                                                value={'child-service-home'}
                                                control={<Radio sx={{ '& .MuiSvgIcon-root': { fontSize: '0.9rem' } }}/>}
                                                label="Child-Service Home (Expert)"
                                                sx={{
                                                    '& .MuiFormControlLabel-label': {
                                                    fontSize: '0.75rem'
                                                    }
                                                }}
                                            />
                                          
                                            <FormControlLabel
                                                value={'serviceBrand'}
                                                control={<Radio sx={{ '& .MuiSvgIcon-root': { fontSize: '0.9rem' } }}/>}
                                                label="Service Brand"
                                                sx={{
                                                    '& .MuiFormControlLabel-label': {
                                                    fontSize: '0.75rem'
                                                    }
                                                }}
                                            />
                                        </RadioGroup>
                                        )}
                                    />
                                </FormControl>
                                {/* {errors?.isSlider && <Typography sx={{fontSize:'0.4rem',color:'#d32f2f'}}>choose one</Typography>} */}
                            </Box>
                        </Grid>
                    </Grid>
                </Grid>
                { (navigateTo == 'category' || navigateTo == 'sub-category' || navigateTo == 'master-service' || navigateTo == 'child-service' || navigateTo == 'child-service-home' || navigateTo == 'serviceBrand') &&
                    <Grid item xs={12}>
                        <Grid container spacing={1} alignItems="center">
                            <Grid item xs={12} sm={3}>
                                <Typography sx={{fontSize:'0.85rem',fontWeight:600}}>Select Category <Box component={'span'} sx={{color:'#d32f2f'}}>*</Box></Typography>
                            </Grid>
                            <Grid item xs={12} sm={9}>
                                <Box sx={{display:'flex',alignItems:'center',gap:1,flexGrow:1,flexDirection:{xs:'column',sm:'row'}}}>
                                    <Controller
                                        name='category'
                                        control={control}
                                        rules={{ required: 'select category' }}
                                        render={({ field, fieldState: { error } }) => (
                                            <Autocomplete
                                                fullWidth
                                                options={categoryList}
                                                getOptionLabel={(option) => option?.title || ''}
                                                isOptionEqualToValue={(option, value) =>
                                                    option.id === (value?.id || value)
                                                }
                                                value={field.value || null}
                                                onChange={(event, newValue) => {
                                                    let finalValue = {
                                                        id: newValue?.id || null,
                                                        title: newValue?.title || '',
                                                    };
                                                    field.onChange(finalValue);
                                                }}
                                                disableClearable
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        // label="Select SAC Code*"
                                                        placeholder='Search and Select Category'
                                                        error={!!error}
                                                        // helperText={error ? error.message : ''}
                                                        size="small"
                                                        inputProps={{
                                                            ...params.inputProps,
                                                            style: { fontSize: '0.75rem' }
                                                        }}
                                                    />
                                                )}
                                                renderOption={(props, option) => (
                                                    <MenuItem {...props} style={{ fontSize: '0.75rem', textTransform: 'capitalize' }}>
                                                        {option.title || ''}
                                                    </MenuItem>
                                                )}
                                            />
                                        )}
                                    />
                                    {loadingCategoryList && <CircularProgress />}
                                </Box>
                            </Grid>
                        </Grid>
                    </Grid>
                }
                { (navigateTo == 'sub-category' || navigateTo == 'master-service' || navigateTo == 'child-service' || navigateTo == 'child-service-home' || navigateTo == 'serviceBrand') &&
                    <Grid item xs={12}>
                        <Grid container spacing={1} alignItems="center">
                            <Grid item xs={12} sm={3}>
                                <Typography sx={{fontSize:'0.85rem',fontWeight:600}}>Select Sub-Category <Box component={'span'} sx={{color:'#d32f2f'}}>*</Box></Typography>
                            </Grid>
                            <Grid item xs={12} sm={9}>
                                <Box sx={{display:'flex',alignItems:'center',gap:1,flexGrow:1,flexDirection:{xs:'column',sm:'row'}}}>
                                    <Controller
                                        name='subCategory'
                                        control={control}
                                        rules={{ required: 'select sub-category' }}
                                        render={({ field, fieldState: { error } }) => (
                                            <Autocomplete
                                                fullWidth
                                                options={subCategoryList}
                                                getOptionLabel={(option) => option?.title || ''}
                                                isOptionEqualToValue={(option, value) =>
                                                    option.id === (value?.id || value)
                                                }
                                                value={field.value || null}
                                                onChange={(event, newValue) => {
                                                    let finalValue = {
                                                        id: newValue?.id || null,
                                                        title: newValue?.title || '',
                                                    };
                                                    field.onChange(finalValue);
                                                }}
                                                disableClearable
                                                disabled={!watch('category')}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        // label="Select SAC Code*"
                                                        placeholder='Search and Select Sub-Category'
                                                        error={!!error}
                                                        // helperText={error ? error.message : ''}
                                                        size="small"
                                                        inputProps={{
                                                            ...params.inputProps,
                                                            style: { fontSize: '0.75rem' }
                                                        }}
                                                    />
                                                )}
                                                renderOption={(props, option) => (
                                                    <MenuItem {...props} style={{ fontSize: '0.75rem', textTransform: 'capitalize' }}>
                                                        {option.title || ''}
                                                    </MenuItem>
                                                )}
                                            />
                                        )}
                                    />
                                    {loadingSubCategoryList && <CircularProgress />}
                                </Box>
                            </Grid>
                        </Grid>
                    </Grid>
                }
                { (navigateTo == 'master-service' || navigateTo == 'child-service' || navigateTo == 'child-service-home' || navigateTo == 'serviceBrand') &&
                    <Grid item xs={12}>
                        <Grid container spacing={1} alignItems="center">
                            <Grid item xs={12} sm={3}>
                                <Typography sx={{fontSize:'0.85rem',fontWeight:600}}>Select Master Service <Box component={'span'} sx={{color:'#d32f2f'}}>*</Box></Typography>
                            </Grid>
                            <Grid item xs={12} sm={9}>
                                <Box sx={{display:'flex',alignItems:{xs:'flex-start',sm:'center'},gap:1,flexGrow:1,flexDirection:{xs:'column',sm:'row'}}}>
                                    <Controller
                                        name='masterService'
                                        control={control}
                                        rules={{ required: 'Select Master Service' }}
                                        render={({ field, fieldState: { error } }) => (
                                            <Autocomplete
                                                fullWidth
                                                options={serviceList}
                                                getOptionLabel={(option) => option?.title || ''}
                                                isOptionEqualToValue={(option, value) =>
                                                    option.masterServiceId === (value?.masterServiceId || value)
                                                }
                                                value={field.value || null}
                                                onChange={(event, newValue) => {
                                                    let finalValue = {
                                                        masterServiceId: newValue?.masterServiceId || null,
                                                        title: newValue?.title || '',
                                                    };
                                                    field.onChange(finalValue);
                                                }}
                                                disableClearable
                                                disabled={!watch('subCategory')}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        // label="Select SAC Code*"
                                                        placeholder='Search and Select Master Service'
                                                        error={!!error}
                                                        // helperText={error ? error.message : ''}
                                                        size="small"
                                                        inputProps={{
                                                            ...params.inputProps,
                                                            style: { fontSize: '0.75rem' }
                                                        }}
                                                    />
                                                )}
                                                renderOption={(props, option) => (
                                                    <MenuItem {...props} style={{ fontSize: '0.75rem', textTransform: 'capitalize' }}>
                                                        {option.title || ''}
                                                    </MenuItem>
                                                )}
                                            />
                                        )}
                                    />
                                </Box>
                            </Grid>
                        </Grid>
                    </Grid> 
                }
                { (navigateTo == 'child-service' || navigateTo == 'child-service-home' || navigateTo == 'serviceBrand') &&
                    <Grid item xs={12}>
                        <Grid container spacing={1} alignItems="center">
                            <Grid item xs={12} sm={3}>
                                <Typography sx={{fontSize:'0.85rem',fontWeight:600}}>Select Child Service <Box component={'span'} sx={{color:'#d32f2f'}}>*</Box></Typography>
                            </Grid>
                            <Grid item xs={12} sm={9}>
                                <Box sx={{display:'flex',alignItems:{xs:'flex-start',sm:'center'},gap:1,flexGrow:1,flexDirection:{xs:'column',sm:'row'}}}>
                                    <Controller
                                        name='childService'
                                        control={control}
                                        rules={{ required: 'Select Child Service' }}
                                        render={({ field, fieldState: { error } }) => (
                                            <Autocomplete
                                                fullWidth
                                                options={childServiceList}
                                                getOptionLabel={(option) => option?.title || ''}
                                                isOptionEqualToValue={(option, value) =>
                                                    option.childServiceId === (value?.childServiceId || value)
                                                }
                                                value={field.value || null}
                                                onChange={(event, newValue) => {
                                                    let finalValue = {
                                                        childServiceId: newValue?.childServiceId || null,
                                                        title: newValue?.title || '',
                                                    };
                                                    field.onChange(finalValue);
                                                }}
                                                disableClearable
                                                disabled={!watch('masterService')}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        // label="Select SAC Code*"
                                                        placeholder='Search and Select Child Service'
                                                        error={!!error}
                                                        // helperText={error ? error.message : ''}
                                                        size="small"
                                                        inputProps={{
                                                            ...params.inputProps,
                                                            style: { fontSize: '0.75rem' }
                                                        }}
                                                    />
                                                )}
                                                renderOption={(props, option) => (
                                                    <MenuItem {...props} style={{ fontSize: '0.75rem', textTransform: 'capitalize' }}>
                                                        {option.title || ''}
                                                    </MenuItem>
                                                )}
                                            />
                                        )}
                                    />
                                </Box>
                            </Grid>
                        </Grid>
                    </Grid> 
                }
                { navigateTo == 'serviceBrand' &&
                    <Grid item xs={12}>
                        <Grid container spacing={1} alignItems="center">
                            <Grid item xs={12} sm={3}>
                                <Typography sx={{fontSize:'0.85rem',fontWeight:600}}>Select Service Brand <Box component={'span'} sx={{color:'#d32f2f'}}>*</Box></Typography>
                            </Grid>
                            <Grid item xs={12} sm={9}>
                                <Box sx={{display:'flex',alignItems:{xs:'flex-start',sm:'center'},gap:1,flexGrow:1,flexDirection:{xs:'column',sm:'row'}}}>
                                    <Controller
                                        name='brand'
                                        control={control}
                                        rules={{ required: 'Select Service Brand' }}
                                        render={({ field, fieldState: { error } }) => (
                                            <Autocomplete
                                                fullWidth
                                                options={brandList}
                                                getOptionLabel={(option) => option?.brandDetail?.title || option?.title || ''}
                                                isOptionEqualToValue={(option, value) =>
                                                    option.brandId === (value?.brandId || value)
                                                }
                                                value={field.value || null}
                                                onChange={(event, newValue) => {
                                                    let finalValue = {
                                                        brandId: newValue?.brandId || null,
                                                        title: newValue?.brandDetail?.title || '',
                                                    };
                                                    field.onChange(finalValue);
                                                }}
                                                disableClearable
                                                disabled={!watch('childService')}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        // label="Select SAC Code*"
                                                        placeholder='Search and Select Service Brand'
                                                        error={!!error}
                                                        // helperText={error ? error.message : ''}
                                                        size="small"
                                                        inputProps={{
                                                            ...params.inputProps,
                                                            style: { fontSize: '0.75rem' }
                                                        }}
                                                    />
                                                )}
                                                renderOption={(props, option) => (
                                                    <MenuItem {...props} style={{ fontSize: '0.75rem', textTransform: 'capitalize' }}>
                                                        {option.brandDetail.title || ''}
                                                    </MenuItem>
                                                )}
                                            />
                                        )}
                                    />
                                </Box>
                            </Grid>
                        </Grid>
                    </Grid> 
                }
                {
                    navigateTo == 'expert-profile' &&
                    <Grid item xs={12}>
                        <Grid container spacing={1} alignItems="center">
                            <Grid item xs={12} sm={3}>
                                <Typography sx={{fontSize:'0.85rem',fontWeight:600}}>Select Expert Profile <Box component={'span'} sx={{color:'#d32f2f'}}>*</Box></Typography>
                            </Grid>
                            <Grid item xs={12} sm={9}>
                                <Box sx={{display:'flex',alignItems:{xs:'flex-start',sm:'center'},gap:1,flexGrow:1,flexDirection:{xs:'column',sm:'row'}}}>
                                    <Controller
                                        name='serviceExpert'
                                        control={control}
                                        rules={{ required: 'Select Service Expert' }}
                                        render={({ field, fieldState: { error } }) => (
                                            <Autocomplete
                                                fullWidth
                                                {...field}
                                                options={expertList || []}
                                                // getOptionLabel={(option) => option?.subCatTitle || ''}
                                                getOptionLabel={(option) => {
                                                    if (!option) return '';
                                                    const expertLabel = option?.UserProfile?.firstName ? `${option.UserProfile.firstName} ${option.UserProfile.lastName}` : '';
                                                    const mobileNumber = option?.mobileNumber ? `(${option.mobileNumber})` : '';
                                                    // const distance = option?.distance ? `(${option.distance} km)` : '';
                                                    return `${expertLabel} | ${mobileNumber} `;
                                                    // return `${expertLabel} | ${mobileNumber} | ${distance}`;
                                                }}
                                                isOptionEqualToValue={(option, value) =>
                                                    option.id === (value?.id || value)
                                                }
                                                onChange={(event, newValue) => {
                                                    field.onChange(newValue ? newValue.id : null);
                                                }}
                                                value={expertList.find(option => option.id === field.value) || null}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        // label="Select SAC Code*"
                                                        placeholder='Search and Select Expert'
                                                        error={!!error}
                                                        // helperText={error ? error.message : ''}
                                                        size="small"
                                                        inputProps={{
                                                            ...params.inputProps,
                                                            style: { fontSize: '0.75rem' }
                                                        }}
                                                    />
                                                )}
                                                renderOption={(props, option) => (
                                                    <MenuItem {...props} style={{ fontSize: '0.75rem', textTransform: 'capitalize' }}>
                                                        {option.UserProfile?.firstName || ''} {option.UserProfile?.lastName || ''} | {option.mobileNumber || ''} 
                                                    </MenuItem>
                                                )}
                                            />
                                        )}
                                    />
                                    {loadingServiceExpertList && <CircularProgress />}
                                </Box>
                            </Grid>
                        </Grid>
                    </Grid> 
                }
                <Grid item xs={12} sx={{display:'flex',justifyContent:'center',gap:1}}>
                    <Button disabled={isSubmitting || !isDirty} size='small' variant='contained' color='primary' type='submit'>{isSubmitting?'please wait...':'Generate App Url'}</Button>
                </Grid>
                <Grid item xs={12}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={10}>
                            <Box sx={{display:'flex',flexDirection:{xs:'column',sm:'row'},alignItems:{xs:'flex-start',sm:'center'},gap:1}}>
                                <Typography sx={{fontSize:'0.85rem',fontWeight:600,width:{xs:'100%',sm:'20%'}}}>App Url <Box component={'span'} sx={{color:'#d32f2f'}}>*</Box></Typography>
                                <Controller
                                    name='appUrl'
                                    control={control}
                                    render={({ field }) => (
                                        <TextField
                                            {...field}
                                            disabled
                                            fullWidth
                                            size='small'
                                            // label="App Url"
                                            InputProps={{
                                                readOnly: true,
                                                style: { fontSize: '0.75rem' }
                                            }}
                                        />
                                    )}
                                />
                            </Box>
                        </Grid>
                        <Grid item xs={12} sm={2} sx={{textAlign:'center'}}>
                            <Button disabled={ !watch('appUrl') ||copiedAppUrl} size='small' variant='contained' color='success' onClick={handleCopy}>{copiedAppUrl?'Copied':'Copy Url'}</Button>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Box>
    </Box>
  );
}

export default GenerateAppUrl;
